import type { SentryEventFilter } from '../types'

const ignoredStatusCodes = [400, 401, 403, 404, 412]
export const filterIgnoredStatusCode: SentryEventFilter = ({ statusCode }) => {
  const parsedStatusCode = Number(statusCode)

  return ignoredStatusCodes.includes(parsedStatusCode)
}
